export default "__VITE_ASSET__yANWTWbZ__"